import React, { useEffect, useState } from 'react'
import { useVendors, useVendorsRequest } from 'src/pages/Vendors/vendors.hooks'
import { GridColumnSortVendorsProps } from './GridColumnSort.constants'
import { getColSortIcon, getNextColSortType } from './GridColumnSort.utils'
import { GridColumnSort } from '.'

export const VendorsGridColumnSort = ({
  type,
  isActive,
  colName,
  onSort,
}: GridColumnSortVendorsProps): JSX.Element | null => {
  const req = useVendorsRequest()
  const { loading } = useVendors(req)
  const [showSpinner, setShowSpinner] = useState<boolean>(loading && isActive)
  const currIcon = getColSortIcon(type, isActive)

  useEffect(() => {
    showSpinner && isActive && setShowSpinner(loading)
  }, [showSpinner, isActive, loading])

  const applySorting = (e: React.MouseEvent) => {
    e.preventDefault()
    if (loading) {
      return
    }
    setShowSpinner(true)
    onSort({ colName, type: getNextColSortType(type) })
  }

  return (
    <GridColumnSort {...{ colName, showSpinner, currIcon, applySorting }} />
  )
}
